import { availableButtonClickEvent } from "./availableButtonClickEvent";
import { timeSlotButtonClickEvent } from "./timeSlotButtonClickEvent";

document.addEventListener("DOMContentLoaded", function (event) {
  availableButtonClickEvent();
});

export function updateTimeSlots() {
  console.log('update time slots')
  let appointmentDuration = document.querySelector('[data-appointment-length]');
  let appointmentLength = appointmentDuration.dataset.appointmentLength;
  // appointment date needs to come from the date input
  let appointmentDate = document.querySelector('[name="date"]').value;
  let tokenNode = document.querySelector('meta[name="csrf-token"]');
  const TOKEN = (tokenNode) ? tokenNode.getAttribute('content') : null;
  const url = `/update_time_slots?appointment_length=${encodeURIComponent(appointmentLength)}&date=${encodeURIComponent(appointmentDate)}`;

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'applicaton/json',
      'Accept': 'applicaton/json',
      'X-CSRF-Token': TOKEN,
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('There was a problem with the request.')
    }
    return response.json();
  }).then(data => {
    // clear out the time slot display and input values
    const appointmentDisplayTimeSlot = document.getElementById('appointmentDisplayTimeSlot');
    appointmentDisplayTimeSlot.innerHTML = '';
    const timeSlotInput = document.querySelector('input[name="time_slot"]');
    timeSlotInput.value = '';


    let timeSlotContainer = document.querySelector('.timeSlot-container');
    timeSlotContainer.innerHTML = '';
    data.forEach((timeSlot) => {
      let timeSlotButton = document.createElement('button');
      timeSlotButton.classList.add('time-slot');
      timeSlotButton.innerHTML = timeSlot;
      timeSlotContainer.appendChild(timeSlotButton);
    });
    timeSlotButtonClickEvent();
  }).catch((error) => {
    console.log('Update time slots error:');
    console.log(error);
  });
}

